import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GoodReceipt } from '../goods-receipt/good-receipt';
import { Stock } from './stock';
import { TransferStockObject } from '../bestand/bestand-element';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';

@Injectable()
export class StockService {
    constructor(
        private readonly http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    transferStock(transferStockObject: TransferStockObject) {
        return this.http.post(this.apiBaseUrl + 'bestand_charge/transfer.php', transferStockObject);
    }

    updateStock(transferStockObject: TransferStockObject) {
        return this.http.post(this.apiBaseUrl + 'bestand_charge/update.php', transferStockObject);
    }

    createStock(goodReceipt: GoodReceipt) {
        return this.http.post(this.apiBaseUrl + 'bestand_charge/create.php', goodReceipt);
    }

    createTierarztBestand(stock: Stock) {
        return this.http.post(this.apiBaseUrl + 'bestand_charge/create_tierarzt.php', stock);
    }
}
